import { all } from 'redux-saga/effects';
import loginSaga from './login.saga';
import registrationSaga from './registration.saga';
import userSaga from './user.saga';
import requestSaga from './request.saga';
import clientSaga from './client.saga';
import partnerSaga from './partner.saga';
import emailSettingsSaga from './emailSettings.saga.js';
import warehouseSaga from './warehouse.saga';
import referralPartnerSaga from './referral.partner.saga';
import statisticsSaga from './statistics.saga';
import ImportCSVSaga from './importData.saga';
import requestNewestSaga from './request.newest.saga';
import requestNameSaga from './request.name.saga';
// rootSaga is the primary saga.
// It bundles up all of the other sagas so our project can use them.
// This is imported in index.js as rootSaga

// some sagas trigger other sagas, as an example
// the registration triggers a login
// and login triggers setting the user

export default function* rootSaga() {
  yield all([
    loginSaga(), // login saga is now registered
    registrationSaga(),
    userSaga(),
    requestSaga(),
    clientSaga(),
    partnerSaga(),
    emailSettingsSaga(),
    warehouseSaga(),
    referralPartnerSaga(),
    statisticsSaga(),
    ImportCSVSaga(),
    requestNewestSaga(),
    requestNameSaga(),
  ]);
}

